import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { useSidebar } from '../../../context/AdminContext';
import '../../../assets/css/admin/adminPageLayout/sidebarmenuitem.css';

const SidebarMenuItem = ({ item }) => {
  const location = useLocation();
  const {
    isSidebarOpen,
    toggleSidebar,
    activeMenu,
    setActiveMenuItem,
    isMenuExpanded,
    toggleMenuExpansion,
  } = useSidebar();

  const Icon = item.icon;
  const isActive = activeMenu === item.id;
  const isExpanded = isMenuExpanded(item.id);
  const hasSubmenu = item.hasSubmenu && item.submenu;

  const handleMenuClick = () => {
    if (hasSubmenu) {
      toggleMenuExpansion(item.id);
    } else {
      setActiveMenuItem(item.id);
    }

    if (window.innerWidth <= 768 && isSidebarOpen) {
      setTimeout(() => toggleSidebar(), 150);
    }
  };

  const handleSubmenuClick = (submenuId) => {
    setActiveMenuItem(submenuId);
    
    if (window.innerWidth <= 768 && isSidebarOpen) {
      setTimeout(() => toggleSidebar(), 150);
    }
  };

  const isSubmenuActive = (path) => location.pathname === path;

  return (
    <div className="jj-sidebar-menu-item">
      {hasSubmenu ? (
        <div
          className={`jj-menu-item ${isActive ? 'jj-menu-item-active' : ''} ${
            !isSidebarOpen ? 'jj-menu-item-collapsed' : ''
          }`}
          onClick={handleMenuClick}
          data-tooltip={!isSidebarOpen ? item.label : undefined}
        >
          <div className="jj-menu-item-content">
            <Icon className="jj-menu-icon" />
            {isSidebarOpen && (
              <>
                <span className="jj-menu-label">{item.label}</span>
                <span className="jj-menu-arrow">
                  {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
                </span>
              </>
            )}
          </div>
        </div>
      ) : (
        <Link
          to={item.path}
          className={`jj-menu-item ${isActive ? 'jj-menu-item-active' : ''} ${
            !isSidebarOpen ? 'jj-menu-item-collapsed' : ''
          }`}
          onClick={handleMenuClick}
          data-tooltip={!isSidebarOpen ? item.label : undefined}
        >
          <div className="jj-menu-item-content">
            <Icon className="jj-menu-icon" />
            {isSidebarOpen && <span className="jj-menu-label">{item.label}</span>}
          </div>
        </Link>
      )}

      {hasSubmenu && isExpanded && isSidebarOpen && (
        <div className="jj-submenu">
          {item.submenu.map((subItem) => (
            <Link
              key={subItem.id}
              to={subItem.path}
              className={`jj-submenu-item ${
                isSubmenuActive(subItem.path) ? 'jj-submenu-item-active' : ''
              }`}
              onClick={() => handleSubmenuClick(subItem.id)}
            >
              <span className="jj-submenu-dot"></span>
              <span className="jj-submenu-label">{subItem.label}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarMenuItem;